import type { TimelineItem } from "../types/content";

export function Timeline({ items, ariaLabel }: { items: TimelineItem[]; ariaLabel: string }) {
  return (
    <ol className="timeline" aria-label={ariaLabel}>
      {items.map((item, index) => (
        <li key={`${item.organization}-${item.title}`} className="timeline-item">
          <div className="timeline-marker"><span>{String(index + 1).padStart(2, "0")}</span></div>
          <article className="timeline-card panel">
            <div className="timeline-date-row">
              <p>{item.dates}</p>
              {item.type && <span>{item.type}</span>}
              {item.badge && <span className="timeline-badge">{item.badge}</span>}
            </div>
            <h3>{item.title}</h3>
            <p className="organization">{item.organization}</p>
            <p className="meta-line">{item.location}</p>
            <p>{item.description}</p>
            <ul className="tag-list">{item.areas.map((area) => <li key={area}>{area}</li>)}</ul>
          </article>
        </li>
      ))}
    </ol>
  );
}
